<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit company images</h2>
    </div>
  </div>
  <div class="modal-body">
    <div class="row spacing-30">
      @if (companyImages.length > 0) {
        <div class="col-lg-12 col-12">
          @for (image of companyImages; track image.image_id) {
            <div class="image-input image-input-outline me-5" data-kt-image-input="true" style="background-image: url(/assets/media/svg/avatars/blank.svg)">
              <div class="image-input-wrapper w-125px h-125px" [style.background-image]="'url(' + image.image_url + ')'"></div>
              <span
                class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
                (click)="deleteImage(image)"
                data-kt-image-input-action="remove"
                data-bs-toggle="tooltip"
                data-bs-dismiss="click"
                title="Remove avatar"
              >
              <i class="ki-outline ki-cross fs-3"></i>
            </span>
            </div>
          }
        </div>
      } @else {
        <p>No images added yet</p>
      }
    </div>
    <div class="row">
      <div class="col-lg-12 col-12">
        <app-fileorini
          [accept]="'.png,.jpg'"
          [maxFiles]="50"
          [maxSizeMB]="20"
          (filesChanged)="onFilesChanged($event)"
        ></app-fileorini>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [label]="'Save'"
      [variant]="'primary'"
      (clicked)="uploadImages()"
    />
  </div>
</div>
